export default __webpack_public_path__ + "static/media/clothesRental.31e43dcd.png";